<div class="white-box main-black">
	<!-- Filters and Export Button -->
	<div class="filter-row py-4 mt-4 p-4 border-radius align-items-end">
		<div class="filter-item">
			<label for="period">{{"perf_analytic.period" | translate}}</label>
			<ng-select
				id="period"
				class="select"
				[items]="periods"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'g.durations' | translate"
				[(ngModel)]="filters.selectedPeriod"
				(change)="formatUtilizationData()"
			></ng-select>
		</div>

		<!-- voltage filter -->
		<div class="filter-item">
			<label for="voltageSelect">{{"exception_reports.charger_voltages" | translate}}</label>
			<ng-select
				id="voltageSelect"
				class="select"
				[items]="voltagesOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'qv.voltage' | translate"
				[(ngModel)]="filters.selectedVoltage"
				(change)="formatUtilizationData()"
			></ng-select>
		</div>

		<!-- Manufacturer filter -->
		<div class="filter-item">
			<label for="manufacturerSelect">{{"devices.charger_manufacturer" | translate}}</label>
			<ng-select
				id="manufacturerSelect"
				class="select"
				[items]="manufacturersOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.charger_manufacturer' | translate"
				[(ngModel)]="filters.selectedManufacturer"
				(change)="formatUtilizationData()"
			></ng-select>
		</div>

		<!-- Todo be added in after adding manufacturing date for chargers -->
		<!-- Vintage filter -->
		<!-- <div class="filter-item">
			<label for="vintageSelect">{{"devices.charger_vintage" | translate}}</label>
			<ng-select
				name="vintageSelect"
				id="vintageSelect"
				class="select"
				[multiple]="true"
				[items]="vintageOptions"
				[addTag]="true"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.charger_vintage' | translate"
				[(ngModel)]="filters.selectedVintage"
				(change)="vintageSelectionChanged()"
			>
				<ng-template ng-label-tmp let-item="item" let-clear="clear">
					<span>
						<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
						<span class="ng-value-label">{{item.label}}</span>
					</span>
				</ng-template>
			</ng-select>
		</div> -->

		<!-- Export Button -->
		<div class="filter-export">
			<button class="btn btn-primary" (click)="exportReports()">{{'g.export' | translate}}</button>
		</div>
	</div>

	<!-- Battery Utilization Metrics -->
	<div class="mt-4 px-4">
		<h4 class="mb-4">{{'utilization_metrics.charger_exception_metrics' | translate}}</h4>
		
		<div class="metrics-row" *ngIf="!isNoData">
			<app-utilization-metric-box
				class="ml-4"
				[title]="'utilization_metrics.charger_asset_utilization_performance' | translate"
				[icon]="'fa fa-line-chart'"
				(metricClicked)="commonService.scrollToWidget($event)"
				[items]="assetUtilization">
			</app-utilization-metric-box>

			<app-utilization-metric-box
				[title]="'utilization_metrics.charger_maintenance' | translate"
				[icon]="'fa fa-warning'"
				[theme]="'yellow'"
				(metricClicked)="commonService.scrollToWidget($event)"
				[items]="maintenance">
			</app-utilization-metric-box>
		</div>
	</div>


	<div class="card-body pt-0" *ngIf="isNoData">
		<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
	</div>

	<app-exception-report-widget
		id="widget-low_charger_utilization"
		[widgetConfig]="widgetsConfig.low_charger_utilization"
		[devices]="devices"
		[data]="lowChargerUtilization"
		[filters]="filters"
	></app-exception-report-widget>

	<app-exception-report-widget
		id="widget-low_charger_ah_utilization"
		[widgetConfig]="widgetsConfig.low_charger_ah_utilization"
		[devices]="devices"
		[data]="lowChargerAhUtilization"
		[filters]="filters"
	></app-exception-report-widget>

	<app-exception-report-widget
		id="widget-low_charger_kwh_utilization"
		[widgetConfig]="widgetsConfig.low_charger_kwh_utilization"
		[devices]="devices"
		[data]="lowChargerKwhUtilization"
		[filters]="filters"
	></app-exception-report-widget>

	<app-exception-report-widget
		id="widget-high_charger_kw_utilization"
		[widgetConfig]="widgetsConfig.high_charger_kw_utilization"
		[devices]="devices"
		[data]="highChargerKwUtilization"
		[filters]="filters"
	></app-exception-report-widget>
</div>

<div class="main-black border-radius-bottom white-box">
	<app-exception-report-widget
		id="widget-disconnected_chargers"
		[widgetConfig]="widgetsConfig.disconnected_chargers"
		[devices]="devices"
		[data]="disconnectedChargers"
		[filters]="filters"
	></app-exception-report-widget>

	<app-exception-report-widget
		id="widget-chargers_outside_geofence"
		[widgetConfig]="widgetsConfig.chargers_outside_geofence"
		[devices]="devices"
		[data]="[]"
		[filters]="filters"
	></app-exception-report-widget>
</div>
